import { SelectInput } from '@coverright/ui/inputs';
import { MenuItem, SelectChangeEvent } from '@mui/material';
import * as React from 'react';
import { PlanYear } from '@coverright/data-access/types/enrollment';

export type PlanSelectorPlan = {bidId: string, planName?: string | null, planYear?: PlanYear | null};

export type PlanSelectorProps = {
  value: string;
  onChange: (plan: PlanSelectorPlan) => void;
  onLoaded?: (plans: PlanSelectorPlan[]) => void;
  error?: string,
  carrierName?: string,
  zip: string;
  county: string;
  planYear?: PlanYear;
  disabled?: boolean;
  loading?: boolean;
};

export const PlanSelector = (props: PlanSelectorProps & {hideBids?: boolean, plans: {bidId: string, planName?: string | null}[]}) => {
  const {value, error, disabled, plans, loading} = props;

  const onChange = (event: SelectChangeEvent<unknown>) => {
    const bidId = event.target.value as string;
    props.onChange(plans.find(p => p.bidId === bidId)!)
  }

  const valueInList = plans.some(p => p.bidId === value);

  return (
    <SelectInput label={'Plan'}
                value={value}
                loading={loading}
                onChange={onChange}
                disabled={loading || disabled}
                error={Boolean(error)}
                helperText={error ? error : undefined}
    >
      {plans.map(p => <MenuItem key={p.bidId} value={p.bidId}>
        {`${props.hideBids ? '' : p.bidId} ${p.planName}`.trim()}
      </MenuItem>)}
      {value && !valueInList && (
        <MenuItem value={value}>{value}</MenuItem>
      )}
    </SelectInput>
  );
};
